import { render, staticRenderFns } from "./LandingFooter.vue?vue&type=template&id=74de4bd1&scoped=true&"
import script from "./LandingFooter.vue?vue&type=script&lang=js&"
export * from "./LandingFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74de4bd1",
  null
  
)

export default component.exports